import './survey.css';
import { SurveyStudentContainer } from "../../../../components/survey/SurveyStudentContainer";

export const MeetingSurveyStudentPage = () => {
  return <SurveyStudentContainer />;
};

export default MeetingSurveyStudentPage;
